export default {
  "": "",
  "24hChange": "24H変動率",
  "24hTurnover": "24時間出来高",
  "action": "アクション",
  "AddLoan": "増加",
  "AdjustLoanFail": "担保額の調整に失敗しました。しばらくしてからもう一度お試しください。 ",
  "all": "すべて",
  "apply": "申請する",
  "assets": "通貨",
  "available": "利用可能",
  "balance": "利用可能残高",
  "bi_all": "すべて",
  "bi_average_change": "24H平均変動率",
  "bi_down_amount": "取引高の少ない銘柄",
  "bi_down_num": "値下がり銘柄",
  "bi_eth_gas": "ETHのガス代",
  "bi_google_tips": "数字は、検索キーワードへの関心度を所定の地域と時間のグラフの最高値を基準として相対的に示したものです。最高値100は、キーワードが最も検索された状態を表します。",
  "bi_google_trends": "GoogleトレンドにおけるBTC",
  "bi_market_cap": "世界の暗号資産時価総額（USDT）",
  "bi_market_distribution": "時価総額分布",
  "bi_market_sentiment": "市場心理",
  "bi_market_trends": "暗号資産市場トレンド",
  "bi_market_volatility": "暗号資産市場のボラティリティ",
  "bi_normal_amount": "取引高の変化がない銘柄",
  "bi_normal_num": "変化なし",
  "bi_page_title": "暗号資産の市況トレンド・センチメント・ボラティリティトラッカー {'|'} Bybit",
  "bi_price_distribution": "価格推移の分布",
  "bi_ranking": "順位",
  "bi_ranking_sector": "カテゴリー",
  "bi_ranking_tips": "現在、この部門の時価総額トップ3の銘柄のみが表示されています。",
  "bi_sentiment1": "極度の恐怖",
  "bi_sentiment2": "恐怖",
  "bi_sentiment3": "おまかせ",
  "bi_sentiment4": "強欲",
  "bi_sentiment5": "極度に強欲",
  "bi_social": "ソーシャルメディアのトレンド",
  "bi_td_trade": "取引する",
  "bi_th_action": "アクション",
  "bi_th_change": "24H変動",
  "bi_th_currency": "通貨",
  "bi_th_market": "時価総額",
  "bi_th_price": "価格",
  "bi_th_sector": "カテゴリー",
  "bi_th_up_down": "上昇銘柄／下落銘柄",
  "bi_th_volume": "24H出来高",
  "bi_top_20": "時価総額",
  "bi_top_gain": "値上がり銘柄 (%上昇)",
  "bi_total_market": "合計時価総額",
  "bi_trading_distribution": "取引高分布",
  "bi_trading_vol": "過去24時間における世界の暗号資産取引高（USDT）",
  "bi_twitter_explore": "Twitterで「話題を検索」",
  "bi_twitter_tips1": "Twitterで話題の新着トピック",
  "bi_twitter_tips2": "Twitterのトレンドトピック",
  "bi_twitter_topics": "Twitter トレンド・トピック",
  "bi_up_amount": "取引高の多い銘柄",
  "bi_up_num": "値上がり銘柄",
  "bi_view": "表示",
  "bi_volume_distribution": "取引高推移の分布",
  "botValidateErrCode101": "最低投資価格が低すぎます。",
  "botValidateErrCode102": "最低投資価格が高すぎます。",
  "botValidateErrCode103": "最高投資価格が低すぎます。",
  "botValidateErrCode104": "最高投資価格が高すぎます。",
  "botValidateErrCode105": "グリッドが少なすぎます。",
  "botValidateErrCode106": "グリッドが多すぎます。",
  "botValidateErrCode107": "投資額が低すぎて、投資要件を満たしていません。",
  "botValidateErrCode108": "投資額が高すぎて、契約の投資枠を超えています。",
  "botValidateErrCode109": "利食価格が低すぎます。",
  "botValidateErrCode110": "利食価格が高すぎます。",
  "botValidateErrCode111": "損切価格が低すぎます。",
  "botValidateErrCode112": "損切価格が高すぎます。",
  "botValidateErrCode113": "参入価格が低すぎます。",
  "botValidateErrCode114": "参入価格が高すぎます。",
  "cancel": "いいえ",
  "cancelAll": "すべてをキャンセル",
  "cancelOrder": "キャンセル",
  "chart": "チャート",
  "close": "閉じる",
  "confirm": "はい",
  "contest-about-to-start": "近日開催",
  "contest-accumulate-volume": "合計取引高",
  "contest-accumulate-volume-start": "参加登録が完了しました！これからの現物取引高がカウントされます。",
  "contest-achieve-standards": "参加対象",
  "contest-activity-rules": "イベント規約",
  "contest-activity-rules-title": "イベント規約",
  "contest-activity-time": "イベント期間",
  "contest-countdown": "終了まで",
  "contest-countdown-day": "日",
  "contest-cumulative-volume": "合計取引高({unit})",
  "contest-current-volume": "現在の取引高",
  "contest-date-range": "{month}{date}日{time} {utc}",
  "contest-dialog-btn-text": "確認",
  "contest-difference-to-foward": "次の順位まであと{num} {unit}",
  "contest-earn-rewards": "獲得特典（{unit}）",
  "contest-ended": "イベント終了",
  "contest-find-more-premium-assets": "多様な現物ペアで取引しよう！",
  "contest-latest-update": "データは{time}{utc}に更新されます。",
  "contest-less": "たたむ",
  "contest-limit-desc": "特典の対象となるには、{amount} {unit}の最低現物取引高条件を満たす必要があります。",
  "contest-list-show-more": "もっと見る",
  "contest-login": "ログイン",
  "contest-month": "1月,2月,3月,4月,5月,6月,7月,8月,9月,10月,11月,12月",
  "contest-my-rank": "マイランキング",
  "contest-no-rank": "ランキングはまだありません。お楽しみに！",
  "contest-no-rank-yet": "ランキングはまだありません",
  "contest-not-registered": "本イベントに参加登録していません。",
  "contest-num-of-participants": "参加者数",
  "contest-popup-success": "取引する",
  "contest-ranking": "ランキング",
  "contest-register": "今すぐ参加登録",
  "contest-registered": "登録済み",
  "contest-registration-ends": "登録期間終了",
  "contest-rewards-earned": "もらえる特典（{unit}）",
  "contest-share": "シェアする",
  "contest-symbol-scope": "現物ペア",
  "contest-terms-conditions": "<p>利用規約：</p>",
  "contest-to-spot-trade": "イベントが始まりました。今すぐ入金・取引しましょう！",
  "contest-u-earned-king": "「現物取引の達人」特典を獲得しました。",
  "contest-u-earned-sunny": "「ランキング入り」特典を獲得しました。",
  "contest-unqualified": "申し訳ございません。お客様は本イベントにご参加いただけません。ご不明な点がございましたら、カスタマーサポートまでお問い合わせください。",
  "contest-updated-daily-at": "*最終更新日時は{time}（UTC+0）です。",
  "contest-will-start-tips": "参加登録が完了しました！イベントは{time}に開始となります。お楽しみに！",
  "contest-your-rewards": "もらえる特典",
  "contract_account": "デリバティブアカウント",
  "createErrorCode400": "お客様から送信されたデータに不正なパラメータが含まれています。詳しくは、エラーメッセージとその詳細をご確認ください。",
  "createErrorCode401": "残高が不足しています。",
  "createErrorCode402": "ボットの作成数が上限に達しました。",
  "createErrorCode403": "禁止",
  "createErrorCode404": "リクエストされたリソースは見つかりませんでした。",
  "createErrorCode407": "お客様のアカウントタイプでは、取引ボットのサブアカウントは作成できません。",
  "createErrorCode408": "定期投資対象が重複して選択されています。",
  "createErrorCode409": "投資限度額が無効です。",
  "createErrorCode410": "投資限度額が無効です。",
  "createErrorCode411": "ボットが終了しました。",
  "createErrorCode412": "USDデリバティブアカウントに更新中",
  "createErrorCode500": "内部サーバーエラー",
  "createErrorCode501": "内部処理のタイムアウト",
  "createErrorCode503": "積立ボットは現在終了できません。買い注文をしている可能性があります。",
  "currency": "通貨",
  "dailyRate": "日次利率",
  "deposit": "入金",
  "detail": "詳細",
  "direction": "方向",
  "end": "終了時間",
  "fiat": "法定通貨",
  "filled": "約定済み",
  "filter": "絞り込む",
  "from": "開始時間",
  "global_setting_quick_order_desc": "<p>1.成行注文（クイック注文）</p>\n<p>2.入力した注文数量と実際に約定された購入数量が若干異なる場合があります。</p>",
  "global_setting_quick_order_label": "クイック注文",
  "global_setting_title": "カスタム設定（現物取引に適用）",
  "hint": "備考",
  "innovateQuota": "購入上限",
  "kline": "チャート",
  "l_version_tip": "Bybitローンチパッドイベントに参加するには、Bybitアプリを最新バージョンにアップデートしてください。",
  "LastTradedPrice": "価格",
  "leverage": "レバレッジ",
  "leverage_can_borrow": "借入可能額",
  "leverage_can_deposit": "証拠金",
  "leverage_data": "証拠金データ",
  "leverage_forced_order": "強制決済注文",
  "leverage_go_trade": "今すぐ取引",
  "leverage_loan_limit": "借入上限額",
  "leverage_min_borrow": "借入下限額",
  "leverage_off_trade_tip": "レバレッジ取引を行うには、まずレバレッジ機能を有効にしてください。",
  "leverage_yearly_rate": "年間利息",
  "leverageCloseErrInfo": "処理に失敗しました。すべての返済を完了してから、マージン取引をオフにしてください。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "USDデリバティブアカウントの必要証拠金と維持証拠金の利用率がしきい値を超えているため、このアクションは完了できません。",
  "leverageLP_banner_title": "Bybitマージン取引",
  "leverageLP-banner-desc": "借入金を投資して利益を増やそう",
  "leverageLP-faq-a1": "<a href=\"{url}\" target=\"_blank\" >担保資産および借入可能資産一覧（マージン取引）</a>より、対象となるすべての暗号資産をご確認いただけます。",
  "leverageLP-faq-a10": "［注文］> ［現物取引の注文］> ［返済履歴］> ［強制決済履歴］をクリックしてご確認いただけます。",
  "leverageLP-faq-a11": "借入と返済の履歴は、［注文］> ［現物取引の注文］> ［返済履歴］よりご確認いただけます。",
  "leverageLP-faq-a2": "Bybitマージン取引では、現物取引手数料、利息、ポジション決済手数料が発生します。手数料の詳細については、<a href=\"{url}\" target=\"_blank\" >Bybitマージン取引：手数料と概要</a>をご覧ください。",
  "leverageLP-faq-a3": "マージン取引では、現物アカウントの暗号資産を担保にして借り入れを行い、レバレッジをかけます。",
  "leverageLP-faq-a4": "いいえ。機関レンディングをご利用の場合は、レバレッジ取引を行うことはできません。Bybitマージン取引をご利用いただくには、institutional_services{'@'}bybit.comまでメールにてご連絡いただき、お客様のUIDを機関レンディングのユーザーリストから削除する必要があります。",
  "leverageLP-faq-a5": "貸出金利は、VIPランクに応じて異なります。詳細は<a href=\"{url}\" target=\"_blank\" >レバレッジデータ</a>をご確認ください。",
  "leverageLP-faq-a6": "利息は1時間単位で計算されます。1時間未満は、1時間としてカウントされますのでご注意ください。",
  "leverageLP-faq-a7": "SMSとメールで2通のリスク通知が届きます。\n\n（1）現物アカウントのリスクレベルが87％以上になると、リスクアラートが発動されます。ポジションの強制決済を回避するため、担保の追加（担保となる資産の振替）を促すSMSとメールの通知が届きます。\n\n（2）現物アカウントのリスクレベルが95％以上になると、SMSとメールで強制決済のアラートが届き、ポジションが強制決済されたことが通知されます。\n\n強制決済のプロセスや基準に関する詳細は、<a href=\"{url}\" target=\"_blank\">リスクと強制決済（現物レバレッジ取引）</a>よりご確認ください。",
  "leverageLP-faq-a8": "マージン取引保険基金（MAF）は、アカウントの資金不足により、借入金返済のための強制決済が行われた際に生じた損失を補填するものです。\n\n現物アカウントが債務超過に陥った場合、BybitがMAFを使用して債務を補填します。そのため、MAFの費用を賄うために強制決済手数料が発生します。",
  "leverageLP-faq-a9": "証拠金を返済に充当した後、まだ未返済の借入金がある場合、残りの損失はマージン取引保険基金が補填します。",
  "leverageLP-faq-q1": "マージン取引で担保資産や借入資産として利用できるのは、どの暗号資産ですか？",
  "leverageLP-faq-q10": "強制決済履歴はどこで確認できますか？",
  "leverageLP-faq-q11": "借入と返済の履歴はどこで確認できますか？",
  "leverageLP-faq-q2": "Bybitマージン取引で手数料は発生しますか？",
  "leverageLP-faq-q3": "マージン取引を行う場合、どのBybitアカウントを使用すればいいですか？",
  "leverageLP-faq-q4": "機関レンディングを利用している場合、マージン取引またはレバレッジ取引を行うことはできますか？",
  "leverageLP-faq-q5": "Bybitマージン取引の貸付金利を教えてください。",
  "leverageLP-faq-q6": "利息発生までの時間はどのくらいですか？",
  "leverageLP-faq-q7": "どのような場合にマージン取引のリスク通知が届きますか？",
  "leverageLP-faq-q8": "マージン取引保険基金とは何ですか？",
  "leverageLP-faq-q9": "強制決済後、現物アカウントの資金が不足していた場合はどうなりますか？",
  "leverageLP-faq-title": "よくある質問",
  "leverageLP-feature-title": "マージン取引を選ぶ理由",
  "leverageLP-feature1": "取引利益の拡大",
  "leverageLP-feature2": "ロングおよびショートポジションに対応",
  "leverageLP-feature3": "資本効率の向上",
  "leverageLP-feature4": "資産の多様化",
  "leverageLP-whats-leverage": "マージン取引とは何ですか？",
  "leverageLP-whats-leverage-c": "Bybitのマージン取引は、現物取引のデリバティブ商品で、暗号資産を担保に資金を借り入れ、レバレッジをかけることができるようにするものです。借入金は、ボラティリティが低い市場と高い市場の両方で、レバレッジをかけたポジションの取引利益を増やすために使用できます。",
  "leverageTest": "マージン取引クイズ",
  "leverageTestSubTitle": "以下のクイズに全問正解されたお客様は、マージン取引をご利用いただけます。",
  "leverageTryAgain": "システムエラーです。後でもう一度お試しください。",
  "liquidate": "強制決済済み",
  "liquidationErrorInfo": "処理に失敗しました。お客様のアカウントで強制決済がトリガーされました。",
  "load_more": "もっと読み込む",
  "loan": "借入",
  "loan_limit": "貸付期間",
  "loan_spot_account": "現物アカウント",
  "loanLualityDeposit1": "現在のLTV比率が初期LTVを下回る場合のみ担保を減額できます。 ",
  "loanLualityDeposit2": "担保の減額の上限とは、LTVを初期水準に戻すために必要な金額を指します。",
  "loanLualityDeposit3": "減額後の金額が調整可能な証拠金を下回る場合、担保額を減らすことはできません。",
  "loanTime": "タイムスタンプ",
  "login": "ログイン",
  "lp_go_home": "戻る",
  "lpn_one_progress_info": "結果発表まで",
  "lpn_order_btn": "コミット済みプロジェクト",
  "lpn_order_btn_cancel": "キャンセル",
  "lpn_order_btn_confirm": "確定",
  "lpn_order_submit_error": "失敗しました",
  "lpn_order_submit_error_desc": "しばらく待ってからもう一度お試しください。",
  "lpn_unfold": "もっと見る",
  "lt_all": "全額",
  "lt_amount": "数量",
  "lt_amount_not_enough": "{currency} の利用可能残高が不足しています。",
  "lt_entry_tips": "{symbol} ({direction})のレバレッジトークン取引に対応しています。今すぐ取引しよう",
  "lt_freerate": "手数料率",
  "lt_lowcase_redemption": "償還",
  "lt_lowcase_subscription": "購入",
  "lt_open_success_txt": "おめでとうございます、レバレッジトークンが利用可能となりました！",
  "lt_orders_submitted": "{ordertype}の{quantity}注文の発注が完了しました。",
  "lt_redemption": "償還",
  "lt_redemption_failed_change_position": "お選びになった通貨ペアではリバランスが発動したため、現在償還には対応しておりません。時間をおいて再度お試しください。",
  "lt_redemption_failed_closed": "お選びになった資産の償還には現在対応しておりません。時間をおいて再度お試しください。",
  "lt_redemption_failed_input_quantity": "償還金額を入力してください",
  "lt_redemption_failed_net_worth": "純資産価値が無効となっているため、現在償還には対応しておりません。時間をおいて再度お試しください。",
  "lt_redemption_failed_wear_position": "お客様のアカウントは強制決済中のため、現在償還には対応しておりません。時間をおいて再度お試しください。",
  "lt_redemption_max_quanlity": "選択中の資産の1取引当たりの最大償還数量は {amount}以上です。",
  "lt_redemption_min_quanlity": "選択中の資産の1取引当たりの最小償還数量は {amount}以下です。",
  "lt_redemption_tips": "実際の償還額とは若干異なる場合があります。",
  "lt_subscription": "購入",
  "lt_subscription_failed_change_position": "お選びになった通貨ペアではリバランスが発動したため、現在購入いただけません。時間をおいて再度お試しください。",
  "lt_subscription_failed_close_position": "お客様のアカウントは強制決済中のため、現在購入いただけません。時間をおいて再度お試しください。",
  "lt_subscription_failed_closed": "お選びになった資産の購入には現在対応しておりません。時間をおいて再度お試しください。",
  "lt_subscription_failed_input_amount": "購入金額を入力してください",
  "lt_subscription_failed_invalid_value": "純資産価値が無効となっているため、現在購入いただけません。時間をおいて再度お試しください。",
  "lt_subscription_failed_large_amount": "購入額が大き過ぎるため、リスクレベルが高くなります。強制決済が実行される可能性があります。",
  "lt_subscription_failed_wear_position": "お客様のアカウントがマイナス資産となっているため、現在購入いただけません。時間をおいて再度お試しください。",
  "lt_subscription_max_amount": "選択中の資産の1取引あたりの最大購入額は {amount}以下です。",
  "lt_subscription_min_amount": "選択中の資産の1取引当たりの最小購入額は {amount}以上です。",
  "lt_subscription_redemption": "購入と償還",
  "lt_subscription_redemption_records": "購入＆償還履歴",
  "lt_subscription_tips": "実際の購入額とは若干異なる場合があります。",
  "lt_subscription_usdt_not_enough": "USDTの利用可能残高が不足しています。先ず入金または資金の振替を行ってください。",
  "lt-landing-banner-desc": "強制決済リスクなしでレバレッジ取引を",
  "lt-landing-banner-title": "Bybit レバレッジトークン",
  "lt-landing-faq-a1": "NAV（純資産価値）とは、レバレッジトークンの価値のことです。レバレッジトークンのNAVは、対応する無期限契約銘柄の価格変動に連動して変動します。",
  "lt-landing-faq-a2": "BTCのレバレッジトークンを例にすると…\n\nBTC3Lは、BTCUSDT無期限契約のロングポジションを3倍のレバレッジで保有するレバレッジドトークンを指します。\n\nBTC3Sは、BTCUSDT無期限契約のショートポジションを3倍のレバレッジで保有するレバレッジドトークンを指します。",
  "lt-landing-faq-a3": "レバレッジトークンは、お客様の現物アカウントで直接取引できます。",
  "lt-landing-faq-a4": "詳細は、<a href=\"{url}\" target=\"_blank\" >レバレッジトークンとデリバティブ取引の違いについて</a>をご参照ください。",
  "lt-landing-faq-a5": "詳細は、<a href=\"{url}\" target=\"_blank\" >Bybitレバレッジトークン：手数料について</a>をご参照ください。",
  "lt-landing-faq-a6": "強制決済のリスクは一切ありません。\n\nBTC3L を例にとると、目標レバレッジの範囲は「2倍～4倍」です。実際のレバレッジ比率が≧4倍または≦2倍になると、リバランスメカニズムが自動的に作動し、目標レバレッジである3倍を達成するように調整されます。\n\n注：レバレッジトークンの純資産価値はゼロになる可能性があり、その場合、回復不可能であることにご注意ください。",
  "lt-landing-faq-a7": "リバランスは、原資産の無期限契約のポジションが目標レバレッジを達成するために動的に調整されるようにするためのプロセスです。実際のレバレッジ比率が目標レバレッジの範囲外になると、リバランスメカニズムが自動的にトリガーされます。\n\n詳細は、<a href=\"{url}\" target=\"_blank\"> Bybitレバレッジトークン：リバランスメカニズムについて</a>をご参照ください。",
  "lt-landing-faq-a8": "現在、出金に対応していません。",
  "lt-landing-faq-q1": "純資産価値（NAV）は何のことですか？",
  "lt-landing-faq-q2": "レバレッジトークンのシンボルは何を表しているのですか？",
  "lt-landing-faq-q3": "Bybitでレバレッジドトークンを取引するには、どのアカウントを使用すればよいですか？",
  "lt-landing-faq-q4": "Bybitでのレバレッジドトークンとデリバティブの取引はどう違うのですか？",
  "lt-landing-faq-q5": "レバレッジトークンの取引手数料について教えてください。",
  "lt-landing-faq-q6": "レバレッジトークンのポジションが強制決済されるのは、どのような状況ですか？",
  "lt-landing-faq-q7": "リバランスメカニズムとは？",
  "lt-landing-faq-q8": "レバレッジトークンは出金することはできますか？",
  "lt-landing-faq-title": "よくある質問",
  "lt-landing-feature-title": "レバレッジトークンの特徴",
  "lt-landing-feature1": "レバレッジを活用して、収益を最大化",
  "lt-landing-feature2": "強制決済リスクなし",
  "lt-landing-feature3": "高い投資収益率",
  "lt-landing-feature4": "取引が簡単",
  "lt-landing-learn-more": "詳細はこちら",
  "lt-landing-operation": "アクション",
  "lt-landing-symbol": "通貨ペア",
  "lt-landing-whats-lt": "レバレッジトークンとは？",
  "lt-landing-whats-lt-c": "レバレッジドトークンは、レバレッジをかけた暗号資産の価格に証拠金なしで連動するデリバティブ商品です。強制決済のリスクなしにレバレッジによる利益を増幅する効果が期待できます。\n\n各レバレッジトークンは、無期限契約のポジションのバスケットで構成されています。 \n\nレバレッジトークンの純資産価値（NAV）は、該当する無期限契約銘柄の価格変動と連動しています。",
  "lt-learning-video-title": "レバレッジトークンの初心者向けビデオ講座",
  "ltLearningVideo": "動画ガイド",
  "ltNav": "純資産価値",
  "ltOpenRiskContent": "レバレッジトークンは、原資産にレバレッジを適用して投資を行うことができます。\n\nBybitは、利用者に事前に通知することなく、利用規約を変更し、市場の状況に応じて以下のいずれかの措置を講じることができるものとします。\n\n1. レバレッジトークンの取扱中止を行う。\n\n2. ポジション数量などの制限を追加/調整します。このような変更が発表された場合は、Bybitブログで詳細をご確認ください。ポジション数量制限が実行された場合、技術的な問題により、実際に利用できる数量が公式発表の数量と異なることがあります。リスクをご理解の上、ご利用ください。 \n\n3. 目標レバレッジを達成するために、原資産のポジションを動的に調整します。\n\n4. 利用規約のいずれかの条項を削除します。\n\nレバレッジトークンの金融商品としての仕組みを十分に理解し、お客様のリスク許容度と専門知識レベルに基づいて合理的に投資を行なってください。Bybitは、レバレッジトークンの取引に伴う損失やリスクについて一切の責任を負いません。\n\n次に進むことにより、お客様はレバレッジトークンの取引に関する<a href={url} target=\"_blank\">利用規約</a>に同意したとみなされます。",
  "ltOpenRiskSubmit": "レバレッジトークンのリスクを受け入れて、利用を始める",
  "ltOpenRiskTitle": "レバレッジトークンサービス契約",
  "ltTestDialogContent": "本当にクイズをやめますか？回答は保存されません。",
  "ltTestDialogContinue": "続ける",
  "ltTestDialogExit": "やめる",
  "ltTestDialogTitle": "確認",
  "ltTestDone": "<span>{numAll}問中{num}問</span>回答済み",
  "ltTestDoneFail": "{numAll}問中{num}問が正解でした。残念！クイズに再挑戦してください。",
  "ltTestPassContent": "おめでとうございます、クイズに合格しました！",
  "ltTestPassRead": "もっと見る",
  "ltTestPassReject": "後で見る",
  "ltTestResubmit": "再挑戦",
  "ltTestSubmit": "送信する",
  "ltTestSubTitle": "レバレッジトークン取引を開始するには、クイズに全問正解する必要があります。",
  "ltTestTitle": "クイズ",
  "ltUnderlying": "原資産",
  "margin_coin": "通貨",
  "margin_discount": "乗数",
  "margin_discount_eg": "例：",
  "margin_discount_eg_body": "田中さんが現物アカウントで1 BTC、1000 BIT、100 TRXを保有していたとします。\nBTC、BIT、TRXの市場価格がそれぞれ50,000 USDT、5 USDT、0.50 USDTの場合、マージン取引の合計担保価額は次のようになります。 \n(1 (数量) × 50000 (価格) × 1 (乗数) × 1) + (1,000 (数量) × 5 (Price) × 0.9 (乗数) + (100 (数量) × 0.5 (価格) × 0 (乗数) = 54,500 USDT",
  "margin_discount_rate": "証拠金の詳細",
  "margin_lq_order": "強制決済注文",
  "MARKET": "市場価格",
  "max": "最大",
  "more": "詳しく見る",
  "network_error": "申請に失敗しました。しばらくしてから、もう一度お試しください。",
  "NEW": "アクティブ",
  "nextPage": "次へ",
  "nodata": "履歴が見つかりませんでした。",
  "none": "なし",
  "noRecordFound": "データなし",
  "og_description": "Bybitの現物取引所で{symbol}を購入、売却、取引しよう。低い手数料と高い流動性で安全な取引を提供します。",
  "og_title": "{symbol} {'|'} 安い手数料で暗号資産を購入、売却、取引しよう {'|'} Bybit 現物取引",
  "ol_agree": "下記の項目について確認・同意します",
  "ol_agrmt": "暗号資産借入契約",
  "ol_agrmt_2": "<暗号資産借入契約>",
  "ol_agrmt_err": "暗号資産借入契約に署名する必要があります。",
  "ol_amt": "借入額",
  "ol_amt_err": "{condition}の借入額：{amount} {unit}",
  "ol_amt_tip": "借入額を入力してください",
  "ol_app_sub": "ローン申請提出済み",
  "ol_app_time": "申請日時",
  "ol_apply_title": "機関レンディングのオンライン申請",
  "ol_cancel": "申請を取り消しますか？",
  "ol_cfm_product": "機関レンディング商品",
  "ol_check_app": "申請状況",
  "ol_coin": "通貨",
  "ol_col_amt": "数量",
  "ol_col_app_tm": "申請時刻",
  "ol_col_dl": "借入期間",
  "ol_col_no": "注文番号",
  "ol_col_pn": "商品名",
  "ol_col_sub": "サブアカウント",
  "ol_confirm": "ローン申請確認",
  "ol_contact_desc": "ご指定のメールアドレスと電話番号にリスクアラート等が送信されます。連絡先が正しく入力されていることをよくご確認ください。",
  "ol_contact_tip": "弊社担当者までご連絡ください",
  "ol_contact_title": "連絡先",
  "ol_detail_title": "ローン申請詳細",
  "ol_eg": "例",
  "ol_email": "メールアドレス",
  "ol_email_err_invalid": "無効なメールアドレス",
  "ol_email_tip": "メールアドレスを入力してください",
  "ol_max": "maximum",
  "ol_mgr": "弊社担当者のID",
  "ol_mgr_err_invalid": "無効なID",
  "ol_mgr_link": "クリックして弊社担当者のIDを表示",
  "ol_mgr_tip": "弊社担当者のIDをご記入ください",
  "ol_min": "minimum",
  "ol_mine_title": "マイローン申請",
  "ol_month": "{month}ヶ月",
  "ol_no_code_rcd": "国番号がありません",
  "ol_notice_desc": "<li>機関レンディングは、機関投資家のお客様のみご利用いただけます。</li>\n<li>ローン申請には、50万USDT以上の資産保有条件を満たす必要があります。</li>\n<li>ローンの種類によっては、現物またはデリバティブ取引への資金利用が可能です。</li>",
  "ol_notice_desc_lmt": "<li>借入金は最小100万USDT～最大2000万USDTまで申請できます。</li>",
  "ol_notice_title": "機関レンディングの仕組み",
  "ol_phone": "携帯電話番号",
  "ol_phone_err": "国番号と携帯電話番号を入力してください",
  "ol_phone_err_invalid": "無効な携帯電話番号",
  "ol_phone_tip": "携帯電話番号を入力してください",
  "ol_prd": "機関レンディング商品を選択してください",
  "ol_prd_3x_spot": "機関レンディング：3倍レバレッジ（現物）",
  "ol_prd_3x_spot_futures": "機関レンディング：3倍レバレッジ（現物とデリバティブ）",
  "ol_prd_5x_spot": "機関レンディング：5倍レバレッジ（現物）",
  "ol_prd_link": "商品概要",
  "ol_prd_tip": "現物アカウント内の資産を担保対象外の資産に両替した場合、強制決済のリスクが高まります。Bybitの現物取引で担保として利用できる資産の詳細については、<a href={url} target=\"_blank\">こちら</a>をご覧ください。",
  "ol_recent_year_only": "過去1年間のローン申請履歴を確認できます。",
  "ol_status": "申請状況",
  "ol_status_list": "すべて,審査済,提出済,却下済,支払済",
  "ol_subacc": "サブアカウントを追加",
  "ol_subacc_tip": "追加したいサブアカウントのUIDを入力してください。複数のサブアカウントを追加する場合は、弊社担当者までご連絡ください。",
  "ol_term": "借入期間",
  "ol_term_err": "借入期間を指定してください。",
  "ol_unit_month": "単位：月",
  "ol_view_agrmt": "契約書の添付ファイルを表示",
  "operationSuccess": "成功",
  "or": "または",
  "orderBook": "取引板",
  "orderHistory": "注文履歴",
  "orderId": "注文ID",
  "orderSuccessful": "注文が発注されました。",
  "orderType": "注文タイプ",
  "otcErrorInfo": "お客様はすでにOTCレンディングを有効化しているため、マージン取引機能をご利用いただけません。",
  "outstanding": "未払い",
  "pa_accumated_profit_descript": "累積利益とは、一定期間内に毎日発生した利益の合計です。チャートは前日時点のデータのみ表示されます。",
  "pa_accumated_profit_select": "実際の累積利益",
  "pa_accumated_profit_title": "累積利益",
  "pa_accumulated_account": "現物アカウントの累積ROI",
  "pa_accumulated_btc": "BTCの累積価格変化率",
  "pa_accumulated_btc_select": "BTCの実際の累積価格変化率",
  "pa_accumulated_pnl": "過去7日間の損益",
  "pa_accumulated_pnl_select": "実際の累積ROI",
  "pa_accumulated_roi_descript": "累積ROIは、一定期間の投資で発生した利益の効率性を評価するものです。チャートは前日時点のデータのみ表示されます。",
  "pa_accumulated_roi_title": "累積ROI",
  "pa_assets_distribution_descript": "資産配分とは、全資産のUSDT値合計に対する現物アカウントの各資産の比重のことです。",
  "pa_assets_distribution_title": "資産配分",
  "pa_daily_pnl": "本日の損益",
  "pa_daily_profit_descript": "日次損益チャートは、前日時点のデータのみを表示しています。",
  "pa_daily_profit_select": "本日の損益",
  "pa_daily_profit_title": "日次損益",
  "pa_last_30_day": "過去30日",
  "pa_last_7_day": "過去7日",
  "pa_last_90_day": "過去90日",
  "pa_others": "その他",
  "pa_page_description": "現物資産の価格変動をリアルタイムでチェックし、投資戦略に活かせます。",
  "pa_page_title": "現物資産の損益分析",
  "pa_quantity": "{Coin}の数量",
  "pa_spot_pnl_descript": "1. 現物資産における損益情報は、毎日の09:00（日本時間）に更新されます。\n2. 現物資産における最新の損益情報は、09:00～15:00（日本時間）以内に計算され、毎日15:00（日本時間）以降に更新されます。",
  "pa_spot_pnl_title": "現物資産の損益分析",
  "pa_total_assets": "総資産価値",
  "pa_total_assets_value_descript": "総資産価値とは、現物アカウントの総資産価値（借入資産を含む）を指すもので、出金、アカウント内振替（入出金）、ローン、マージン取引の影響を受けます。",
  "pa_total_assets_value_select": "資産価値",
  "pa_total_assets_value_title": "総資産価値",
  "pa_update_on": "最終更新時：",
  "pa_value": "{Coin}の価値",
  "pa_weightage": "{Coin}の割合",
  "pauseTradeTip": "{symbol}は現在取引できません。詳しくは<a href={url} target=\"_blank\">こちらのブログ記事</a>をご確認ください。",
  "placeHolder": "選択する",
  "prevPage": "前へ",
  "price": "価格",
  "quantity": "数量",
  "ReduceLoan": "減少",
  "ReduceLoanAssets": "担保額を減らす",
  "ReduceLoanTip1": "担保額を減らすには、現在のLTVが初期LTVを下回らなければなりません。  ",
  "ReduceLoanTip2": "担保額を減らすには、減額後の金額が調整可能な証拠金を下回らなければなりません。",
  "ReduceLoanTip3": "現在のLTVが初期LTVを上回る場合、担保額を減らすことはできません。もう一度お試しください。 ",
  "ReduceLoanTip4": "担保額は注文ページで管理できます。担保はいつでも増やすことができます。ただし、減らす場合は現在のLTV比率が初期LTVを下回る必要があります。 ",
  "repayment": "返済",
  "reset": "リセット",
  "reverse_contract_account": "インバースアカウント",
  "riskWarning": "リスクの確認",
  "search": "検索",
  "side": "売り/ 買い",
  "signup": "登録",
  "spot_account": "現物アカウント",
  "status": "状態",
  "stop_limit": "利食/損切",
  "stop_limit_tips_2": "アクティブな利食・損切注文がある場合は、マージン取引を有効にすることはできません。",
  "success": "完了",
  "sure": "sure",
  "tests1": "",
  "times": "回",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit現物取引  ",
  "to": "～",
  "toastTheSymbolNotExist": "お選びになった現物ペアは、現在取引に利用できません。",
  "total": "合計",
  "tradeChange": "変化率",
  "tradeId": "トランザクションID",
  "transfer": "資産振替",
  "usdc_contract_account": "USDCデリバティブアカウント",
  "VIP99": "VVIP",
  "volume": "約定数量",
  "vote_btn_trade": "取引する"
}